import { render, staticRenderFns } from "./LayoutHome.vue?vue&type=template&id=000f4b37&"
import script from "./LayoutHome.vue?vue&type=script&lang=js&"
export * from "./LayoutHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports